import React from 'react';
import PropTypes from 'prop-types';
// Components
import {
  GeckoCardWrapper,
  GeckoCardHeader,
  GeckoCardBody,
  GeckoCardFooter,
  GeckoTable,
  GeckoPagination,
  GeckoAlert,
} from '../';

// Models
import {
  GeckoBtnsModel,
  GeckoTableCellsModel,
  GeckoPaginationModel,
  GeckoTableMassActionModel,
} from '../../models';

const GeckoCardTable = (props) => {
  const renderHeader = () => {
    return (
      <GeckoCardHeader
        icon={props.headerIcon}
        name={props.name}
        btns={props.headerBtns}
        onSearch={props.onSearch}
        link={props.link}
        filter={props.filter}
        {...props.headerProps}
      />
    );
  };

  const renderTable = () => {
    return (
      <GeckoCardBody>
        <GeckoTable
          rows={props.rows}
          cols={props.cols}
          rowHandler={props.rowHandler.bind(this)}
          pagination={props.pagination}
          hideTableHeader={props.hideTableHeader}
          massAction={props.massAction}
        />
      </GeckoCardBody>
    );
  };

  const renderAlert = () => {
    let alertContent = <span>There are no results to show.</span>;
    if (props.alert && props.link) {
      alertContent = (
        <span>
          {props.alert} Click <a href={props.link}>here</a> to get started.
        </span>
      );
    } else if (props.alert && props.newLinkHandler) {
      alertContent = (
        <span>
          {props.alert} Click{' '}
          <span className="link" onClick={() => props.newLinkHandler()}>
            here
          </span>{' '}
          to get started.
        </span>
      );
    }

    return (
      <GeckoCardBody padded>
        <GeckoAlert type="warning">{alertContent}</GeckoAlert>
      </GeckoCardBody>
    );
  };

  const renderBody = () => {
    if (props.rows && props.rows.length) {
      return renderTable();
    }
    return renderAlert();
  };

  const renderFooter = () => {
    if (props.pagination) {
      return (
        <GeckoCardFooter>
          <GeckoPagination pagination={props.pagination} />
        </GeckoCardFooter>
      );
    }
  };

  return (
    <GeckoCardWrapper>
      {renderHeader()}

      {renderBody()}

      {renderFooter()}
    </GeckoCardWrapper>
  );
};

GeckoCardTable.defaultProps = {
  headerBtns: [],
  cols: [],
  rows: [],
  hideTableHeader: false,
  rowHandler: () => {},
  pagination: {},
};

GeckoCardTable.propTypes = {
  headerBtns: GeckoBtnsModel,
  cols: GeckoTableCellsModel.isRequired,
  rows: PropTypes.array.isRequired,
  hideTableHeader: PropTypes.bool,
  rowHandler: PropTypes.func,
  newLinkHandler: PropTypes.func,
  pagination: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape(GeckoPaginationModel),
  ]),
  massAction: GeckoTableMassActionModel,
};

export default GeckoCardTable;
